import '../../../../dmView/style/App.css';
import {vocab, schoolOfSpell, titleCase} from '../../../replacements.js';
import { BoldifyReplace } from '../BoldifyReplace.js';
import { useState } from 'react';

const calcCastingTime = (spell) => {
    let unit = vocab[spell?.time[0]?.unit]
    if(unit !== 'Action' && unit !== 'Bonus action' && unit !== 'Reaction')
        unit = `${spell.time[0].number} ${unit}` 

    if(spell.time[0].number !== 1) 
        unit += 's'

    if(spell?.meta?.ritual)
        unit += ' or ritual'

    return unit

}

const calcComponents = (spell) => {

    let components = Object.entries(spell.components).map(([key, value]) => {
        let component = null
        if(value) {
            component = key.toUpperCase()
            if(typeof value === 'string') {
                component += " (" + value + ")"
            } else if(typeof value === 'object') {
                component += " (" + value.text + ")"
            }
        }

        return component
    }).join(", ")

    return components
}

const calcSourceTitle = (title) => {
    if(title === 'XPHB')
        return '2024'

    if(title === 'PHB')
        return '2014'

    return title
}

const calcRange = (spell) => {
    if(spell.range?.distance?.type === 'self') {
        return 'Self'
    } else if(spell.range?.distance?.type === 'touch') {
        return 'Touch'
    } else if(spell.range?.type === 'special') {
        return 'Special'
    } else {
        return `${spell.range.distance.amount} ${titleCase(spell.range.distance.type)}`
    }
}

const SpellBlock = ({spell, enableCollapse=false}) => {
    const [collapse, setCollapse] = useState(!enableCollapse);

    const handleCollapse = () => {
        if(enableCollapse) {
            setCollapse(!collapse);
        }
    }

    if(!spell) {
        return null;
    } else return (
        <div className='spellBlockContainer'>
            <div className={enableCollapse ? `spellBlockHoverTitle` : ``} onClick={() => handleCollapse()} style={{cursor: enableCollapse ? 'pointer' : 'default'}}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '5px'}}>
                    <div className='topSpellInfo shadowBox'>
                        <span className='titleFontFamily'><b>{spell?.name}</b></span>
                    </div>
                    <span><i> -  {spell.level === 0 ? `${schoolOfSpell[spell.school]} Cantrip` : `Level ${spell.level} ${schoolOfSpell[spell.school]}`}</i></span>
                    {enableCollapse && 
                        <>
                            <span><i> -  {calcSourceTitle(spell?.source)}</i></span>
                            <div style={{marginLeft: 'auto', cursor: 'pointer', display: enableCollapse ? 'block' : 'none'}}>
                                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                                    verticalAlign: "middle",
                                    transition: "transform 0.2s",
                                    transform: collapse ? "rotate(0deg)" : "rotate(90deg)"
                                }}>
                                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </>
                    }
                </div>
                <hr className="lineSeperator" />
            </div>
            <div className='' style={{maxHeight: collapse ? '200px' : '0', overflowY: 'scroll', transition: 'max-height .4s ease-in-out'}}>
                <div className='spellStatGrid' >
                    <span><strong className='titleColor'>Casting Time:</strong> {calcCastingTime(spell)}</span>
                    <span><strong className='titleColor'>Range:</strong> {calcRange(spell)}</span>
                    <span><strong className='titleColor'>Components:</strong> {calcComponents(spell)}</span>
                    <span><strong className='titleColor'>Duration:</strong> {spell?.duration[0]?.concentration && "Concentration, "} {spell.duration[0].type === 'timed' ? spell.duration[0].duration.amount + ' ' + spell.duration[0].duration.type + 's' : vocab[spell.duration[0].type]}</span>
                </div>
                <hr className="lineSeperator" />
                <span>
                    {spell.entries.map(entry => {
                        if(typeof entry === 'string')
                            return <ul className='spellList2'><li key={entry} style={{padding: '0', margin: '8px 0px 0px 0px'}}><BoldifyReplace desc={entry}/></li></ul>
                        else if(typeof entry === 'object') {
                            if(entry.type === "table") {
                                return <table className='spellTable'>
                                            <tr>
                                                {entry.colLabels.map((label) => {
                                                    return <th><BoldifyReplace desc={label} /></th>
                                                })}
                                            </tr>
                                            {entry.rows.map((row) => {
                                                return <tr>
                                                            {row.map((rowData, index) => {
                                                                if(typeof rowData === 'object') {
                                                                    if(rowData.roll?.exact)
                                                                        return <td className='spellTableDice'>{rowData.roll.exact}</td>
                                                                    else 
                                                                        return <td className='spellTableDice'>{rowData.roll.min} - {rowData.roll.max}</td>
                                                                } else {
                                                                    return <td className={index ? "" : "spellTableDice"}><BoldifyReplace desc={rowData}/></td>
                                                                }
                                                            })}
                                                        </tr>
                                            })}
                                        </table>
                            } else if(entry?.type === 'quote') {
                                return  <div className='quote'>
                                            <ul className='quoteList'>
                                                {entry.entries.map(quote => {
                                                    return <li key={entry?.by}><i>"<BoldifyReplace desc={quote}/>"</i></li>
                                                })}
                                            </ul>
                                            <span className='quoteBy'>- {entry?.by}</span>
                                        </div>
                            } else if(entry?.items) {
                                return  <ul className='spellList'>
                                            {entry.items.map(item => {
                                                if(item?.entries)
                                                    return <li key={item.name}><strong className='titleColor'>{item.name}: </strong><BoldifyReplace desc={item.entries.join(" ")}/> </li>
                                                else 
                                                    return <li key={item}><BoldifyReplace desc={item}/></li>

                                            })}
                                        </ul>
                            } else {
                                return <ul className='spellList' style={{paddingTop: '0', paddingBottom: '0', marginTop: '0', marginBottom: '0'}}>
                                        <li style={{padding: '4px'}}>
                                            <strong className='titleColor'>{entry.name}: </strong>
                                            <BoldifyReplace desc={entry.entries.join(" ")}/> 
                                        </li>
                                    </ul>
                            }
                        } else return null
                    })}
                    {spell?.entriesHigherLevel?.map(lvlObj => {
                        return <div key={lvlObj.name} style={{padding: '4px 4px 4px 0px'}}><strong className='titleColor'>{lvlObj.name}: </strong>
                            {lvlObj.entries.map(desc => {
                                return <BoldifyReplace key={lvlObj.name} desc={desc}/> 
                            })}
                        </div>
                    })}
                </span>
                <hr className="lineSeperator" />
                <span>{spell?.source} - {spell?.page}</span>
            </div>
        </div>
    );
}

export default SpellBlock;
